import { useMutation } from "@tanstack/react-query"
import { resendLoginOtp } from "@/api"

export const useResendLoginOtp = () => {
  return useMutation({
    mutationFn: ({ userId, userType }: { userId: number, userType: string }) =>
      resendLoginOtp({ userId, userType }),
  })
}
